import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { IUIRuntime } from '@cian/mf-registry/browser';
import { IMicrofrontendManifest, IRegistry } from '@cian/mf-registry/shared';

import {
  fetchGetNewbuildingBrokerModalsMicroFrontend,
  TGetNewbuildingBrokerModalsMicroFrontendResponse,
} from '../../repositories/newbuilding-broker-modals-micro-frontend/v1/get-newbuilding-broker-modals-micro-frontend';

interface IParams {
  httpApi: IHttpApi;
  logger: ILogger;
  microfrontendsRegistry: IRegistry;
}

export const registerNewbuildingBrokerModalsManifest = async ({
  httpApi,
  logger,
  microfrontendsRegistry,
}: IParams): Promise<IMicrofrontendManifest | null> => {
  try {
    const {
      response: { manifest },
    }: TGetNewbuildingBrokerModalsMicroFrontendResponse = await fetchGetNewbuildingBrokerModalsMicroFrontend({
      httpApi,
    });
    const image = microfrontendsRegistry.register(manifest);

    if (typeof window !== 'undefined') {
      await image.runtimeStrict<IUIRuntime>(manifest.runtimeName).ensure();
    }

    return manifest;
  } catch (error) {
    logger.error(error, { domain: 'services#registerNewbuildingBrokerModalsManifest()' });

    return null;
  }
};
